import type { TOC } from '@ember/component/template-only';
import type TasProgramTemplateModel from 'tio-data/models/tas-program-template';
import { t } from 'ember-intl';
import TioFaqs from '../../tio/faqs.gts';
import { Section } from 'tio-ui/components/layout';

export interface S {
  Args: {
    model: TasProgramTemplateModel;
  };
}

const TasProgramTemplateReviewApproverInstructionsAndFaqs: TOC<S> = <template>
  <Section>
    <:header>
      {{t
        "common.tuition_assistance.program_template_review.approver_instructions_and_faqs.default"
      }}
    </:header>
    <:body>
      <div class="mb-4 flex gap-2">
        <p class="font-semibold">
          {{t "common.tuition_assistance.program_template_review.remove_process_description_steps"}}
        </p>
        <p>
          {{if @model.hideProcessDescriptionSteps (t "common.yes") (t "common.no")}}
        </p>
      </div>
      <article class="grid grid-cols-5 gap-8 mb-4 ml-2">
        <h2 class="tio-text-sm-semibold col-span-5 uppercase">
          {{t
            "common.tuition_assistance.program_template_review.approver_instructions_and_faqs.approver_instructions"
          }}
        </h2>
        {{#each @model.programApproverInstructions as |instruction|}}
          <p class="col-span-1">
            {{t
              "common.tuition_assistance.program_template_review.approver_instructions_and_faqs.instruction"
            }}
            {{instruction.ordinal}}
          </p>
          <p class="col-span-4">{{instruction.body}}</p>
        {{/each}}
      </article>

      <article>
        <h2 class="tio-text-sm-semibold my-4 uppercase">
          {{t "common.frequently_asked_questions"}}
        </h2>
        {{#each @model.programFaqs as |faq|}}
          <TioFaqs @question={{faq.heading}} @answer={{faq.body}} />
        {{/each}}
      </article>
    </:body>
  </Section>
</template>;

export default TasProgramTemplateReviewApproverInstructionsAndFaqs;
